import PageHeader from "components/PageHeader";
import DSSegmentedTabs, {
  SegmentedTabOption,
} from "views/system-design/DSSegmentedTabs";
import useTabParam from "components/hooks/useTabParam";
import { useNumberOfCollectionsWaitingForPublish } from "components/hooks/useNumberOfCollectionsWaitingForPublish";
import ApprovedCollections from "./ApprovedCollections";
import CollectionCodes from "./CollectionCodes";
import CollectionOrders from "./CollectionOrders";
import CollectionLabels from "./CollectionLabels";
import CollectionInProgress from "./CollectionInProgress";
import DraftCollections from "./DraftCollections";
import AffiliateClockStatsWidget from "../../Dashboard/components/AffiliateClockStatsWidget";

type CollectionsLayout =
  | "collections"
  | "waiting"
  | "drafts"
  | "codes"
  | "orders"
  | "labels"
  | "in-progress"
  | "editions";

const LAYOUT_OPTIONS: SegmentedTabOption<CollectionsLayout>[] = [
  { label: "Collections", value: "collections" },
  { label: "Waiting for Publish", value: "waiting" },
  { label: "Drafts", value: "drafts" },
  { label: "Collection In Progress", value: "in-progress" },
  { label: "Editions", value: "editions" },
  { label: "Codes", value: "codes" },
  { label: "Orders", value: "orders" },
  { label: "Labels", value: "labels" },
];

const Collections = () => {
  const [tabParam, setLayout] = useTabParam(
    "tab",
    "collections",
    LAYOUT_OPTIONS.map((o) => o.value),
  );
  const layout = tabParam as CollectionsLayout | undefined;
  const { data: collectionsWaitingForPublish } =
    useNumberOfCollectionsWaitingForPublish();

  const layoutOptions = LAYOUT_OPTIONS.map((option) =>
    option.value === "waiting"
      ? { ...option, badge: collectionsWaitingForPublish }
      : option,
  );

  return (
    <>
      <PageHeader
        overline="Content"
        title="Collections"
        subtitle="Curated klydo packs, codes and orders"
        tabs={
          <DSSegmentedTabs
            options={layoutOptions}
            value={layout}
            onChange={setLayout}
          />
        }
      />
      {layout === "collections" && <ApprovedCollections />}
      {layout === "waiting" && <ApprovedCollections waiting />}
      {layout === "drafts" && <DraftCollections />}
      {layout === "in-progress" && <CollectionInProgress />}
      {layout === "codes" && <CollectionCodes />}
      {layout === "orders" && <CollectionOrders />}
      {layout === "labels" && <CollectionLabels />}
      {layout === "editions" && <AffiliateClockStatsWidget />}
    </>
  );
};

export default Collections;
